var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ref, get } from "firebase/database";
import { database } from "../config/firebaseConfig";
import JSZip from "jszip";
/**
 * Fetches a single collection by ID
 */
var fetchCollection = function (collectionId) { return __awaiter(void 0, void 0, void 0, function () {
    var snapshot, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, get(ref(database, "collections/".concat(collectionId)))];
            case 1:
                snapshot = _a.sent();
                return [2 /*return*/, snapshot.val()];
            case 2:
                error_1 = _a.sent();
                console.error("Failed to fetch collection ".concat(collectionId, ":"), error_1);
                return [2 /*return*/, null];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * Fetches a workspace by ID to get its collections
 */
var fetchWorkspace = function (workspaceId) { return __awaiter(void 0, void 0, void 0, function () {
    var snapshot, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, get(ref(database, "workspaces/".concat(workspaceId)))];
            case 1:
                snapshot = _a.sent();
                return [2 /*return*/, snapshot.val()];
            case 2:
                error_2 = _a.sent();
                console.error("Failed to fetch workspace ".concat(workspaceId, ":"), error_2);
                return [2 /*return*/, null];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * Downloads an image and returns it as a blob
 */
var downloadImage = function (url) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, fetch(url)];
            case 1:
                response = _a.sent();
                if (!response.ok)
                    throw new Error("HTTP ".concat(response.status));
                return [4 /*yield*/, response.blob()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_3 = _a.sent();
                console.error("Failed to download image: ".concat(url), error_3);
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * Sanitizes a filename to be safe for file systems
 */
var sanitizeFilename = function (name) {
    return name.replace(/[/\\?%*:|"<>]/g, "-").trim() || "untitled";
};
/**
 * Map of MIME types to file extensions
 */
var mimeToExtension = {
    "image/jpeg": ".jpg",
    "image/png": ".png",
    "image/gif": ".gif",
    "image/webp": ".webp",
    "image/svg+xml": ".svg",
    "image/bmp": ".bmp",
    "image/tiff": ".tiff",
    "image/x-icon": ".ico",
    "image/vnd.microsoft.icon": ".ico",
    "image/heic": ".heic",
    "image/heif": ".heif",
    "image/avif": ".avif",
};
/**
 * Valid image extensions to check against
 */
var validImageExtensions = new Set([
    "jpg",
    "jpeg",
    "png",
    "gif",
    "webp",
    "svg",
    "bmp",
    "tiff",
    "tif",
    "ico",
    "heic",
    "heif",
    "avif",
]);
/**
 * Checks if a filename has a valid image extension
 */
var hasValidImageExtension = function (filename) {
    var match = filename.match(/\.([a-zA-Z0-9]+)$/);
    if (!match)
        return false;
    return validImageExtensions.has(match[1].toLowerCase());
};
/**
 * Gets file extension from content type, blob type, or defaults
 */
var getExtension = function (storedContentType, imageName, blobType) {
    // If the image name already has a valid image extension, don't add one
    if (hasValidImageExtension(imageName))
        return "";
    // Try stored content type first
    if (storedContentType && mimeToExtension[storedContentType]) {
        return mimeToExtension[storedContentType];
    }
    // Try blob's detected type
    if (blobType && mimeToExtension[blobType]) {
        return mimeToExtension[blobType];
    }
    // Default to .jpg as most common image format
    return ".jpg";
};
/**
 * Downloads all images from all workspaces the user has access to
 * and creates a ZIP file for download
 */
export var downloadAllUserImages = function (workspaceIds, onProgress) { return __awaiter(void 0, void 0, void 0, function () {
    var zip, totalImages, downloadedImages, updateProgress, allImages, _i, workspaceIds_1, workspaceId, workspace, workspaceName, _a, _b, collectionRef, collection, collectionName, _c, _d, image, usedFilenames, _e, allImages_1, _f, image, workspaceName, collectionName, imageBlob, extension, filename, basePath, fullPath, counter, nameParts, ext, zipBlob, downloadUrl, link, error_4;
    var _g;
    return __generator(this, function (_h) {
        switch (_h.label) {
            case 0:
                zip = new JSZip();
                totalImages = 0;
                downloadedImages = 0;
                updateProgress = function (status, message) {
                    onProgress === null || onProgress === void 0 ? void 0 : onProgress({
                        status: status,
                        current: downloadedImages,
                        total: totalImages,
                        message: message,
                    });
                };
                _h.label = 1;
            case 1:
                _h.trys.push([1, 14, , 15]);
                updateProgress("fetching", "Fetching your workspaces...");
                allImages = [];
                _i = 0, workspaceIds_1 = workspaceIds;
                _h.label = 2;
            case 2:
                if (!(_i < workspaceIds_1.length)) return [3 /*break*/, 8];
                workspaceId = workspaceIds_1[_i];
                return [4 /*yield*/, fetchWorkspace(workspaceId)];
            case 3:
                workspace = _h.sent();
                if (!workspace)
                    return [3 /*break*/, 7];
                workspaceName = sanitizeFilename(workspace.name || "Workspace");
                if (!((_g = workspace.collections) === null || _g === void 0 ? void 0 : _g.length))
                    return [3 /*break*/, 7];
                _a = 0, _b = workspace.collections;
                _h.label = 4;
            case 4:
                if (!(_a < _b.length)) return [3 /*break*/, 7];
                collectionRef = _b[_a];
                return [4 /*yield*/, fetchCollection(collectionRef.id)];
            case 5:
                collection = _h.sent();
                if (!(collection === null || collection === void 0 ? void 0 : collection.images))
                    return [3 /*break*/, 6];
                collectionName = sanitizeFilename(collection.name || "Collection");
                for (_c = 0, _d = Object.values(collection.images); _c < _d.length; _c++) {
                    image = _d[_c];
                    allImages.push({
                        image: image,
                        workspaceName: workspaceName,
                        collectionName: collectionName,
                    });
                }
                _h.label = 6;
            case 6:
                _a++;
                return [3 /*break*/, 4];
            case 7:
                _i++;
                return [3 /*break*/, 2];
            case 8:
                totalImages = allImages.length;
                if (totalImages === 0) {
                    updateProgress("complete", "No images found to download.");
                    return [2 /*return*/];
                }
                updateProgress("downloading", "Downloading ".concat(totalImages, " images..."));
                usedFilenames = new Set();
                _e = 0, allImages_1 = allImages;
                _h.label = 9;
            case 9:
                if (!(_e < allImages_1.length)) return [3 /*break*/, 12];
                _f = allImages_1[_e], image = _f.image, workspaceName = _f.workspaceName, collectionName = _f.collectionName;
                return [4 /*yield*/, downloadImage(image.path)];
            case 10:
                imageBlob = _h.sent();
                if (imageBlob) {
                    extension = getExtension(image.contentType, image.name, imageBlob.type);
                    filename = "".concat(sanitizeFilename(image.name)).concat(extension);
                    basePath = "".concat(workspaceName, "/").concat(collectionName);
                    fullPath = "".concat(basePath, "/").concat(filename);
                    counter = 1;
                    while (usedFilenames.has(fullPath)) {
                        nameParts = filename.split(".");
                        if (nameParts.length > 1) {
                            ext = nameParts.pop();
                            filename = "".concat(nameParts.join("."), "_").concat(counter, ".").concat(ext);
                        }
                        else {
                            filename = "".concat(filename, "_").concat(counter);
                        }
                        fullPath = "".concat(basePath, "/").concat(filename);
                        counter++;
                    }
                    usedFilenames.add(fullPath);
                    zip.file(fullPath, imageBlob);
                }
                downloadedImages++;
                updateProgress("downloading", "Downloaded ".concat(downloadedImages, " of ").concat(totalImages, " images..."));
                _h.label = 11;
            case 11:
                _e++;
                return [3 /*break*/, 9];
            case 12:
                updateProgress("zipping", "Creating ZIP file...");
                return [4 /*yield*/, zip.generateAsync({
                        type: "blob",
                        compression: "DEFLATE",
                        compressionOptions: { level: 6 },
                    })];
            case 13:
                zipBlob = _h.sent();
                downloadUrl = URL.createObjectURL(zipBlob);
                link = document.createElement("a");
                link.href = downloadUrl;
                link.download = "substratum-images-".concat(new Date().toISOString().split("T")[0], ".zip");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(downloadUrl);
                updateProgress("complete", "Successfully downloaded ".concat(downloadedImages, " images!"));
                return [3 /*break*/, 15];
            case 14:
                error_4 = _h.sent();
                console.error("Failed to download images:", error_4);
                updateProgress("error", "An error occurred while downloading images.");
                throw error_4;
            case 15: return [2 /*return*/];
        }
    });
}); };
